import * as v from "valibot";
import { rpcContract } from "../rpc";

// Valibot schema for visuals
const visualsSchema = v.object({
  hero_background_url: v.optional(v.pipe(v.string(), v.url())),
  creator_avatar_url: v.optional(v.pipe(v.string(), v.url())),
  brand_logo_url: v.optional(v.pipe(v.string(), v.url())),
});

// Valibot schema for content
const contentSchema = v.object({
  greeting_text: v.optional(v.pipe(v.string(), v.maxLength(100))),
  intro_text: v.optional(v.pipe(v.string(), v.maxLength(500))),
  benefits: v.optional(v.pipe(v.array(v.pipe(v.string(), v.maxLength(200))), v.maxLength(5))),
  cta_text: v.optional(v.pipe(v.string(), v.maxLength(200))),
  urgency_text: v.optional(v.pipe(v.string(), v.maxLength(200))),
  closing_text: v.optional(v.pipe(v.string(), v.maxLength(500))),
  signature_text: v.optional(v.pipe(v.string(), v.maxLength(100))),
});

// Valibot schema for settings
const settingsSchema = v.optional(
  v.object({
    show_countdown: v.optional(v.boolean()),
    countdown_hours: v.optional(v.pipe(v.number(), v.minValue(1), v.maxValue(168))),
    primary_color: v.optional(v.pipe(v.string(), v.regex(/^#[0-9A-F]{6}$/i))),
    button_style: v.optional(v.union([v.literal("rounded"), v.literal("square")])),
  }),
);

// Valibot schema for ExclusiveHighlightV1Customization
export const exclusiveHighlightV1CustomizationSchema = v.object({
  template_type: v.literal("exclusive-highlight-v1"),
  visuals: visualsSchema,
  content: contentSchema,
  settings: settingsSchema,
});

export const saveEmailCustomizationRpcContract = rpcContract({
  name: "save-email-customization",
  paramsSchema: v.object({
    linkId: v.pipe(v.string("linkId must be a string"), v.uuid("Invalid linkId: must be a valid UUID")),
    influencer_id: v.pipe(
      v.string("influencerId must be a string"),
      v.uuid("Invalid influencerId: must be a valid UUID (e.g., 123e4567-e89b-12d3-a456-426614174000)"),
    ),
    customization: exclusiveHighlightV1CustomizationSchema,
  }),
  resultSchema: v.object({
    success: v.boolean(),
    error: v.optional(v.string()),
  }),
});

export type SaveEmailCustomizationParams = v.InferOutput<(typeof saveEmailCustomizationRpcContract)["paramsSchema"]>;
export type SaveEmailCustomizationResult = v.InferOutput<(typeof saveEmailCustomizationRpcContract)["resultSchema"]>;
